export const categoryAssemble = (packageList) => {
    const uniqueCategories = Array.from(
        new Map(
            packageList.flatMap((pkg) =>
                pkg.BasicInfo?.Category?.map((cat) => [
                    cat.Id,
                    {
                        id: cat.Id,
                        name: cat.Name,
                        imageUrl:
                            cat.ImageUrl?.[0] ||
                            "images/no_image_SP.jpg",
                    },
                ])
            )
        ).values()
    );
    return uniqueCategories
}


export const sortPackages = (filteredPackages, sortType) => {
    return [...filteredPackages].sort((a, b) => {
        switch (sortType) {
            case "priceLowToHigh":
                return (
                    parseFloat(a?.FareDetails?.Total || 0) -
                    parseFloat(b?.FareDetails?.Total || 0)
                );
            case "priceHighToLow":
                return (
                    parseFloat(b?.FareDetails?.Total || 0) -
                    parseFloat(a?.FareDetails?.Total || 0)
                );

            case "nameLowToHigh":
                return a?.PackageName?.localeCompare(b?.PackageName);
            case "nameHighToLow":
                return b?.PackageName?.localeCompare(a?.PackageName);

            case "durationLowToHigh":
                return (
                    parseInt(a?.Criteria?.NumberOfNights || 0, 10) -
                    parseInt(b?.Criteria?.NumberOfNights || 0, 10)
                );
            case "durationHighToLow":
                return (
                    parseInt(b?.Criteria?.NumberOfNights || 0, 10) -
                    parseInt(a?.Criteria?.NumberOfNights || 0, 10)
                );

            default:
                return 0;
        }
    });

}


export const getStarClassName = (rating) => {
    const starWords = [
        "zerostar",
        "onestar",
        "twostar",
        "threestar",
        "fourstar",
        "fivestar",
    ];
    return starWords[rating] || "unknownstar";
};


export const handleFilter = (packageResult, filters) => {
    const { starRatings, priceRange, typeFilter } = filters;
    return packageResult.filter((pkg) => {
        const packageStarRating =
            parseInt(pkg.Features?.StarRating, 10) || 0;
        const packagePrice = parseFloat(pkg.FareDetails?.Total || 0);
        const includes = pkg.Features?.Includes || [];

        const isStarMatch =
            starRatings.length === 0 ||
            starRatings.includes(packageStarRating);
        const isPriceMatch =
            priceRange.length === 0 ||
            (packagePrice >= priceRange[0] &&
                packagePrice <= priceRange[1]);
        const isTypeMatch =
            !typeFilter || includes.includes(typeFilter);
        return isStarMatch && isPriceMatch && isTypeMatch;
    });

};

export const assembleCountry = (packageResult) => {
    return Array.from(
        new Set(
            packageResult
                .flatMap((pkg) => pkg.BasicInfo?.Country || [])
                .map((country) => country?.Name)
                .filter(Boolean)
        )
    );

}


export const sortClass = (expression) => {
    const sortOptions = {
        priceLowToHigh: { type: 'price', lowToHigh: true },
        priceHighToLow: { type: 'price', lowToHigh: false },
        nameLowToHigh: { type: 'name', lowToHigh: true },
        nameHighToLow: { type: 'name', lowToHigh: false },
        durationLowToHigh: { type: 'duration', lowToHigh: true },
        durationHighToLow: { type: 'duration', lowToHigh: false }
    };

    return sortOptions[expression] || {};
};